<template>
  <div
    :class="`w-full flex flex-col motion-safe:animate-pulse motion-reduce:animate-none ${containerExtraClasses ? ' ' + containerExtraClasses : null}`"
  >
    <span
      :class="`${widthClass} h-22 mt-2 bg-text-disabled`"
      aria-hidden="true"
    />
    <span class="sr-only">{{ textForScreenReader }}</span>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  containerExtraClasses?: string;
  textForScreenReader: string;
  textRowWidth?:
    | 10
    | 20
    | 30
    | 40
    | 50
    | 60
    | 70
    | 80
    | 100
    | 120
    | 150
    | 175
    | 200
    | 'full';
}

const props = withDefaults(defineProps<Props>(), {
  containerExtraClasses: undefined,
  textRowWidth: 'full',
});

const widthClass = computed(() => {
  switch (props.textRowWidth) {
    case 10:
      return 'w-10';
    case 20:
      return 'w-20';
    case 30:
      return 'w-30';
    case 40:
      return 'w-40';
    case 50:
      return 'w-50';
    case 60:
      return 'w-60';
    case 70:
      return 'w-70';
    case 80:
      return 'w-80';
    case 100:
      return 'w-100';
    case 120:
      return 'w-120';
    case 150:
      return 'w-150';
    case 175:
      return 'w-175';
    case 200:
      return 'w-200';
    case 'full':
      return 'w-full';
    default:
      return 'w-full';
  }
});
</script>
